import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { obj_type, union_type, array_type, option_type, tuple_type, int32_type, record_type, bool_type, string_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Tickets_TicketType_All, Tickets_TicketStatus_All, Tickets_Severity_All, Tickets_Severity, Tickets_Segment_All, Tickets_TicketType_$reflection, Tickets_TicketStatus_$reflection, Tickets_Severity_$reflection, Tickets_Segment_$reflection } from "../Shared/Shared.js";
import { append } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { Tickets_TicketMeta_$reflection } from "../Shared/ApiDataTypes.js";
import { FetchError, FetchError_$reflection } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, Result_DefaultWith, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51, fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry2 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6, toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { API_Tickets_Tickets } from "../Shared/Urls.js";
import { testRedirect, extraCoders } from "../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { unwrap, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString as toString_1 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString as fromString_1 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Cmd_OfPromise_either } from "../fable_modules/Fable.Elmish.4.0.0/cmd.fs.js";

export class Sort extends Record {
    constructor(Key, Asc) {
        super();
        this.Key = Key;
        this.Asc = Asc;
    }
}

export function Sort_$reflection() {
    return record_type("Kundeweb.Tickets.TicketCenterModel.Sort", [], Sort, () => [["Key", string_type], ["Asc", bool_type]]);
}

export class Filter extends Record {
    constructor(SearchTerm, IncludeClosed, ResponsibleOnly, DateRange, SelectedCompany, SelectedDepartment, SelectedSegments, SelectedSeverities, SelectedStatus, SelectedTypes) {
        super();
        this.SearchTerm = SearchTerm;
        this.IncludeClosed = IncludeClosed;
        this.ResponsibleOnly = ResponsibleOnly;
        this.DateRange = DateRange;
        this.SelectedCompany = SelectedCompany;
        this.SelectedDepartment = SelectedDepartment;
        this.SelectedSegments = SelectedSegments;
        this.SelectedSeverities = SelectedSeverities;
        this.SelectedStatus = SelectedStatus;
        this.SelectedTypes = SelectedTypes;
    }
}

export function Filter_$reflection() {
    return record_type("Kundeweb.Tickets.TicketCenterModel.Filter", [], Filter, () => [["SearchTerm", string_type], ["IncludeClosed", bool_type], ["ResponsibleOnly", bool_type], ["DateRange", option_type(tuple_type(int32_type, int32_type))], ["SelectedCompany", option_type(int32_type)], ["SelectedDepartment", option_type(int32_type)], ["SelectedSegments", array_type(Tickets_Segment_$reflection())], ["SelectedSeverities", array_type(Tickets_Severity_$reflection())], ["SelectedStatus", array_type(Tickets_TicketStatus_$reflection())], ["SelectedTypes", array_type(Tickets_TicketType_$reflection())]]);
}

export function Filter_get_empty() {
    let array_1;
    return new Filter("", true, false, undefined, undefined, undefined, Tickets_Segment_All(), (array_1 = [new Tickets_Severity(0, [])], append(Tickets_Severity_All(), array_1)), Tickets_TicketStatus_All(), Tickets_TicketType_All());
}

export class Model extends Record {
    constructor(Tickets, CreateForm, Filter, FilterModalOpen, ErrorMsg) {
        super();
        this.Tickets = Tickets;
        this.CreateForm = CreateForm;
        this.Filter = Filter;
        this.FilterModalOpen = FilterModalOpen;
        this.ErrorMsg = ErrorMsg;
    }
}

export function Model_$reflection() {
    return record_type("Kundeweb.Tickets.TicketCenterModel.Model", [], Model, () => [["Tickets", option_type(array_type(Tickets_TicketMeta_$reflection()))], ["CreateForm", option_type(Tickets_TicketType_$reflection())], ["Filter", Filter_$reflection()], ["FilterModalOpen", bool_type], ["ErrorMsg", option_type(string_type)]]);
}

export class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AddTicket", "SetError", "SetFilter", "SetSearchTerm", "SetSelectedCompany", "SetSelectedDepartment", "SetSelectedSegment", "SetSelectedSeverity", "SetSelectedStatus", "SetSelectedTypes", "TicketsResponse", "ToggleCreateForm", "ToggleFilterModal", "ToggleIncludeClosed", "ToggleResponsibleOnly", "Ignore"];
    }
}

export function Message_$reflection() {
    return union_type("Kundeweb.Tickets.TicketCenterModel.Message", [], Message, () => [[], [["Item", option_type(string_type)]], [["Item", Filter_$reflection()]], [["Item", string_type]], [["Item", option_type(int32_type)]], [["Item", option_type(int32_type)]], [["Item", array_type(Tickets_Segment_$reflection())]], [["Item", array_type(Tickets_Severity_$reflection())]], [["Item", array_type(Tickets_TicketStatus_$reflection())]], [["Item", array_type(Tickets_TicketType_$reflection())]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Tickets_TicketMeta_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Tickets_TicketMeta_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", option_type(Tickets_TicketType_$reflection())]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], []]);
}

function getFilter() {
    const json = localStorage.getItem("ticket-center-filter");
    return Result_DefaultWith((err) => {
        console.debug("[TicketCenter] getFilter get failed", err);
        return Filter_get_empty();
    }, fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(Filter_$reflection(), undefined, undefined)), json));
}

export function storeFilter(filter) {
    const jsonStr = toString(0, Auto_generateBoxedEncoder_437914C6(Filter_$reflection(), undefined, undefined, undefined)(filter));
    console.debug("[TicketCenter] storeFilter: %o -> %s", filter, jsonStr);
    const pr = Promise.resolve(jsonStr);
    return pr.then((json) => {
        localStorage.setItem("ticket-center-filter", json);
    });
}

export function fetchTickets(includeClosed, responsibleOnly) {
    let properties_2;
    const url = API_Tickets_Tickets(includeClosed, responsibleOnly);
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Tickets_TicketMeta_$reflection()), undefined, undefined);
    const data_1 = undefined;
    const caseStrategy_2 = undefined;
    const extra_2 = extraCoders;
    try {
        const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString_1(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Tickets_TicketMeta_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString_1(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    return pr_1.then((result_1) => Result_MapError(testRedirect, result_1));
}

export function init() {
    return [new Model(undefined, undefined, getFilter(), false, undefined), Cmd_OfPromise_either(() => fetchTickets(true, false), undefined, (Item) => (new Message(10, [Item])), (arg_1) => (new Message(1, [arg_1.message])))];
}

